import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation updateUcceMrd($id: ID!, $model: UcceMrdInput!) {
  updateUcceMrd(id: $id, ucceMrd: $model){
    id
    activitiesLimit
    mrdId
    mrdName
    scriptSelector
    channelTypes
  }
}`;

function updateUcceMrd(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateUcceMrd);
}

export default updateUcceMrd;
